/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const DeleteSvg = () => (
  <svg width="1em" height="1em" viewBox="1.5 1.5 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_19_3073)">
      <path d="M2.66663 4.66669H13.3333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.66663 7.33331V11.3333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.33337 7.33331V11.3333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.33337 4.66669L4.00004 12.6667C4.00004 13.0203 4.14052 13.3594 4.39056 13.6095C4.64061 13.8595 4.97975 14 5.33337 14H10.6667C11.0203 14 11.3595 13.8595 11.6095 13.6095C11.8596 13.3594 12 13.0203 12 12.6667L12.6667 4.66669" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>

);

export const DeleteIcon = props => <Icon component={DeleteSvg} {...props} />;
